import { HomePage } from './home.page';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from './../shared-module/shared.module';
import { ComponentsModule } from './../../components/components.module';

const routes: Routes = [
  {
    path: '',
    component: HomePage,
  }
];

@NgModule({
  imports: [
    FormsModule,
    IonicModule,
    SharedModule,
    CommonModule,
    ComponentsModule,
    RouterModule.forChild(routes),
  ],
  declarations: [
    HomePage
  ]
})
export class HomePageModule {}
